import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var arrow = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 14 8", fill: "currentColor", width: size || "14", height: size || "8" }, props),
        React.createElement("g", { id: "Page-1", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { id: "3", transform: "translate(-343 -81)", fill: "currentColor" },
                React.createElement("path", { id: "drop", d: "M355.895556 81L350 86.8195777 344.104444 81 343 82.0886756 350 89 357 82.0886756z" })))));
};
arrow.displayName = 'arrow';
export default arrow;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=arrow.js.map